import { render, staticRenderFns } from "./StandardsCreate.vue?vue&type=template&id=736df7b1"
import script from "./StandardsCreate.vue?vue&type=script&lang=js"
export * from "./StandardsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports